import jQuery from "jquery";

export function initMaxItems() {
	jQuery('ul[data-max-items]').each(function() {
		const list = $(this);
		const items = list.find('li');
		const maxItems = list.data('maxItems') || 10;
		const hiddenItems = items.filter(() => !jQuery(this).hasClass('active')).slice(maxItems);

		const toggle = function() {
			hiddenItems.toggleClass('hidden');
			list.find('.toggle-bar i').toggleClass('fa-caret-down fa-caret-up');
		};

		if(hiddenItems.length < 1) {
			return;
		}

		const toggleElem = $('<li class="toggle-bar"><i class="fa fa-caret-up"></i></li>');
		toggleElem.click(function() {
			toggle();
		});

		list.append(toggleElem);
		toggle();
	});
}
